import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";
import relationService from "~/modules/relation/service/relation.service";

export function useDeleteReferentUser(params: GenericParameters) {
  let service =
    relationService.deleteBusinessUnitReferentUser.bind(relationService);

  if (params.organizationCode) {
    service =
      relationService.deleteOrganizationReferentUser.bind(relationService);
  }

  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function deleteReferentUser() {
    isLoading.value = true;
    error.value = undefined;

    const response = await service(params);

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    deleteReferentUser,
    isLoading,
    error,
  };
}
